export default {
  DELETE_CIRCUIT: 'DELETE_CIRCUIT',
  DELETE_MV_CIRCUITS: 'DELETE_MV_CIRCUITS',
  DELETE_JOB: 'DELETE_JOB',
  DELETE_REEL: 'DELETE_REEL',
  REMOVE_CIRCUIT_FROM_REEL: 'REMOVE_CIRCUIT_FROM_REEL',
  EDIT_CIRCUITS: 'EDIT_CIRCUITS',
  EDIT_MV_CIRCUITS: 'EDIT_MV_CIRCUITS'
};
